import { InfoCircle, Plus, XClose } from '@untitled-ui/icons-react';
import React from 'react';
import { ArrayPath, Control, Controller, Path, useFieldArray } from 'react-hook-form';

import Button from '@/components/ui/Button';
import Input from '@/components/ui/Input';

type FieldArrayProps<T> = {
  control: Control<T>;
  name: ArrayPath<T>;
  maxCount: number;
  label: string;
  description?: string;
  addonBefore?: string;
  placeholder: string;
  appendButtonText: string;
  className?: string;
};

// TODO: fix field array types, remove any types
const FieldArray = <T,>({
  control,
  name,
  maxCount,
  label,
  description,
  addonBefore,
  placeholder,
  appendButtonText,
  className,
}: FieldArrayProps<T>) => {
  const { fields, append, remove } = useFieldArray<T>({
    control,
    name,
    rules: {
      minLength: 1,
      maxLength: maxCount,
    },
  });

  return (
    <div className={className}>
      <div className="flex gap-[10px] mb-2 items-center">
        <label className="font-medium text-gray-10">{label}</label>
        <InfoCircle className="text-[#B9B9B9]" height={24} />
      </div>
      {description && <p className="mb-2 text-gray-500 text-sm">{description}</p>}
      {(fields as any as { id: string; value: string }[]).map((field, index) => (
        <div key={field.id} className="flex mb-2 gap-2 justify-between items-center">
          <Controller
            name={`${name}[${index}].value` as Path<T>}
            control={control}
            render={({ field }) => (
              <Input leftSide={addonBefore} value={field.value as string} onChange={field.onChange} placeholder={placeholder} />
            )}
          />

          {index > 0 && (
            <button
              type="button"
              onClick={() => remove(index)}
              className="flex h-12 w-12 justify-center bg-[#F5F5F5] rounded-[8px] items-center"
            >
              <XClose className="text-gray-10" height={24} />
            </button>
          )}
        </div>
      ))}

      {fields.length < maxCount && (
        <Button onClick={() => append({ value: '' } as any)} type="button" className="mt-2 inline-flex px-4 justify-between">
          <Plus />
          <span>{appendButtonText}</span>
        </Button>
      )}
    </div>
  );
};

export default FieldArray;
